import React from 'react';

import { Box, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { TextBlock } from '@bcp-nextgen-dx-component-factory/design-system';
import { Tooltip } from '@components';

import { SimulationValuesDescriptionProps } from './simulationValuesDescription';

export const SimulationValuesDescriptionBcp: React.FC<SimulationValuesDescriptionProps> = (
	props: SimulationValuesDescriptionProps
) => {
	const { currency = '%', label, promoValue, value, decimalScale = 3, labelNote, tooltip } = props;

	return (
		<Box styles={{ flexDirection: 'column' }}>
			<Box>
				<Typography colorToken="secondary-light" appearance="microcopy-100-06">
					{label}
				</Typography>
				{tooltip && <Tooltip {...tooltip} />}
			</Box>
			{labelNote && (
				<Typography colorToken="secondary-light" appearance="microcopy-100-06">
					{labelNote}
				</Typography>
			)}
			{typeof value === 'number' && (
				<TextBlock.Currency
					size={'medium'}
					floatValue={value}
					decimalScale={decimalScale}
					currency={currency}
					fontWeight={'strong'}
				></TextBlock.Currency>
			)}
			{typeof value === 'string' && (
				<Typography colorToken="primary-light" appearance="headline-100-01">
					{value}
				</Typography>
			)}
			{promoValue && (
				<TextBlock.Currency
					size={'small'}
					floatValue={promoValue}
					decimalScale={decimalScale}
					currency={currency}
					fontWeight={'base'}
					strikeThrough
				></TextBlock.Currency>
			)}
		</Box>
	);
};
